
export const assertMetadata = (metadata) => {
  if (!metadata) { throw new Error('Metadata cannot be undefined.') }
  const requiredProperties = ['page', 'isSoftDelete', 'urls']
  requiredProperties.forEach(property => {
    if (metadata[property] === undefined) { throw new Error(`Metadata must contain '${property}' property!`) }
  });
}